import { render, staticRenderFns } from "./HomeMiddle2.vue?vue&type=template&id=775c5786&"
import script from "./HomeMiddle2.vue?vue&type=script&lang=js&"
export * from "./HomeMiddle2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports